
<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>菜单信息</h3>
      <el-form>
        <div style="display:flex">
          <el-form-item label="请选择门店" style="margin-right:20px">
            <el-select v-model="formInline.shop_id" placeholder="请选择" @change="getCategory()">
              <el-option
                v-for="index in typeData"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div
            style="width:100px;margin-left:10px;margin-top:40px"
            class="vubuttons"
            @click="onSubmit"
          >添加菜品</div>
        </div>
      </el-form>
      <div style="width:100%;height:auto;display:flex">
        <div class="webLists">
          <div class="webList_1_a">
            <div
              :class="item.id===formInline.category_ids&&'webList_1_a_names name_color'||'webList_1_a_names' "
              style="cursor:default"
              v-for="(item,index) in categoryData"
              :key="index"
            >
              <i v-if="item.status==2" class="el-icon-star-on" style="color:#f00;margin-left:10px"></i>
              <div class="right_i" @click="()=>categoryList(item.id)">{{item.name}}</div>
              <div class="right_is">
                <span v-if="item.status!==2" @click="activeMenu(item)">激活</span>
                <span style="margin-left:10px " @click="onSubmit_ca(item)">修改</span>
                <span style="color:#f00;margin-left:10px " @click="handleDelete(item)">删除</span>
              </div>
            </div>
          </div>

          <div class="bottom_centers_y">
            <div style="flex:1" class="vubuttons" @click="onSubmit_ca">新建菜单</div>
          </div>
        </div>
        <div class="webList_2ss" style="margin-left:10px" v-if="categoryData.length">
          <div class="webList_1_a_name">堂食</div>
          <div v-for="item in tableData" :key="item.id">
            <div
              :class="item.id==user_dish_list_id&&'webList_2_list name_color'||'webList_2_list'"
              style="cursor:default"
              @click="getEdit(item)"
              v-if="item.dish.dish_type===1"
            >
              <img :src="item.dish.dish_base.image" class="webList_2_img" />
              <div>
                <div class="webList_2_name">{{item.dish.dish_base.name||'暂无商品名称'}}</div>
                <div
                  class="webList_2_value"
                  v-for="items in item.dish.dish_unit_prices"
                  :key="items.id"
                >
                  <div>规格价格：{{ items.price }}元/{{items.dish_unit.unit_amount}}{{items.dish_unit.name}}</div>
                  <div>计量单位：{{ items.dish_unit.display_name }}</div>
                </div>
                <div style="color:#f00" @click="getEdits(item)">修改价格</div>
              </div>
            </div>
          </div>
        </div>
        <div class="webList_2ss" style="margin-left:10px" v-if="categoryData.length">
          <div class="webList_1_a_name">外卖</div>
          <div v-for="item in tableData" :key="item.id">
            <div
              :class="item.id==user_dish_list_id&&'webList_2_list name_color'||'webList_2_list'"
              style="cursor:default"
              @click="getEdit(item)"
              v-if="item.dish.dish_type===2"
            >
              <img :src="item.dish.dish_base.image" class="webList_2_img" />
              <div>
                <div class="webList_2_name">{{item.dish.dish_base.name||'暂无商品名称'}}</div>
                <div
                  class="webList_2_value"
                  v-for="items in item.dish.dish_unit_prices"
                  :key="items.id"
                >
                  <div>规格价格：{{ items.price }}元/{{items.dish_unit.unit_amount}}{{items.dish_unit.name}}</div>
                  <div>计量单位：{{ items.dish_unit.display_name }}</div>
                </div>
                <div style="color:#f00" @click="getEdits(item)">修改价格</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表弹框 -->
    <el-dialog title="菜品信息" :visible.sync="dialogFormVisible"  :close-on-click-modal="false">
      <el-form>
        <el-form-item label="请选择菜单" :label-width="'100px'">
          <el-select v-model="formInline.menu_id" placeholder="请选择">
            <el-option
              v-for="index in categoryData"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择基础菜品" :label-width="'100px'">
          <el-select
            v-model="formInline.dish_id"
            filterable
            placeholder="请选择"
            @change="getTypeDish"
          >
            <el-option v-for="item in menuList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜品信息" :label-width="'100px'">
          <el-input v-model="activeNames" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-for="item in activeList"
          :key="item.id"
          :label="item.dish_type==1&&'堂食信息'||'外卖信息'"
          :label-width="'100px'"
        >
          <el-form-item label="名称信息" :label-width="'100px'">
            <el-input v-model="item.dish_base.name" disabled autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="标签信息" :label-width="'100px'">
            <span v-for="i in item.dish_attr_map" :key="i.id">{{i.dish_attr_value.value}}</span>
          </el-form-item>
          <el-form-item label="类目信息" :label-width="'100px'">
            <span v-for="i in item.category_dishes" :key="i.id">{{i.category.name}}</span>
          </el-form-item>
          <el-form-item label="规格信息" :label-width="'100px'">
            <el-form-item
              v-for="s in item.dish_unit_prices"
              :key="s.id"
              :label="s.dish_unit.unit_amount+''+s.dish_unit.name+'/'+s.dish_unit.display_name"
              :label-width="'100px'"
            >
              <div>价格：{{s.price/100}}元</div>
              <div>vip价格：{{s.vip_price/100}}元</div>
            </el-form-item>
          </el-form-item>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="setStore()">确认新增</el-button>
    </el-dialog>

    <!-- //新增菜单 -->
    <el-dialog title="菜单信息" :visible.sync="dialogFormVisible_ca">
      <el-form :model="ca_form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="ca_form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="ca_form.intro" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="setStore_ca()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- //修改价格 -->
    <el-dialog title="菜品价格修改" :visible.sync="dialogFormVisibles">
      <el-form :model="dishprice" v-if="dishprice.dish">
        <el-form-item label="名称" :label-width="'100px'">
          <el-input v-model="dishprice.dish.dish_base.name" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="'100px'">
          <el-input v-model="dishprice.dish.dish_base.intro" disabled autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="价格" :label-width="'100px'">
          <el-input v-model="dishprice.dish.dish_unit_prices[0].price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="vip价格" :label-width="'100px'">
          <el-input v-model="dishprice.dish.dish_unit_prices[0].vip_price" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibles=false">取 消</el-button>
        <el-button type="primary" @click="setStore_cas()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script scoped>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      platform: '',
      tabsClick: 0,
      activeNames: '请选择基础菜品',
      activeList: [],
      //列表数据
      tableData: [],
      // 门店数据
      typeData: [],

      // 类目数据
      categoryData: [],

      // 绑定参数
      formInline: {
        // 门店
        shop_id: '',
        //搜索
        name: '',
        //类目
        category_ids: '',
        //标签
        dish_attr_value_ids: '',
        dish_id: '',
        menu_id: '',
        dish_unit_id: '',
        vip_price: '',
        price: '',
      },
      // 弹窗控住
      dialogFormVisible: false,
      dialogFormVisible_ca: false,
      dialogFormVisibles: false,

      // 类目新增
      ca_form: {},
      // 宽度
      formLabelWidth: '120px',
      // 是否修改
      putStatus: false,
      user_dish_list_id: '',
      menuList: [],
      dishprice: {},
    };
  },
  methods: {
    tabsCo(index, a, b) {},

    handleClick() {
      let data = {
        shop_id: this.formInline.shop_id,
      };
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_base_platform
      } else {
        baseUrl = this.$userList.user_dish_base
      }

      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.menuList = res.data.items.map(item => {
            item.label = item.name;
            item.children = [];
            return item;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 获取列表
    getTypeDish(e) {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_list_platform
      } else {
        baseUrl = this.$userList.user_dish_list
      }
      const url = baseUrl + '/0/99';

      const data = {
        dish_base_id: e,
      };
      this.$http.get(url, data).then(res => {
        if (res.code === 200) {
          if (res.data.items.length) {
            res.data.items = res.data.items.filter(itemx => {
              if (itemx.dish_type) {
                return itemx;
              }
            });
          }
          if (res.data.items.length < 1) {
            if (!res.data.items.length) {
              this.activeNames = '门店暂无该商品！请添加后重试。';
              this.activeList = [];
            }
            return;
          } else {
            const lists = [];
            res.data.items.map(item => {
              lists.push(item.dish_type);
            });
            //如果存在返回值的下标，不存在返回-1
            if (lists.indexOf(1) !== -1 && lists.indexOf(2) !== -1) {
              this.activeNames = res.data.items[0].dish_base.name;
            } else {
              this.activeNames =
                (lists.indexOf(1) !== -1 &&
                  '门店外卖暂无该商品！请添加后重试。') ||
                '门店堂食暂无该商品！请添加后重试。';
            }
            this.activeList = res.data.items;
          }

          console.log(res);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    testData(data) {
      let test = true;
      for (let index in data) {
        if ((!data[index] && data[index] !== 0) || data[index] === null) {
          test = false;
        }
      }
      return test;
    },
    setStore_ca() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_platform
      } else {
        baseUrl = this.$userList.user_menu
      }
      let datas = {};
      if (this.ca_form.id) {
        datas = {
          id: this.ca_form.id,
          name: this.ca_form.name,
          intro: this.ca_form.intro,
          shop_id: this.formInline.shop_id,
        };
      } else {
        datas = {
          name: this.ca_form.name,
          intro: this.ca_form.intro,
          shop_id: this.formInline.shop_id,
        };
      }
      if (!this.testData(datas)) {
        this.$alert('菜单信息不能为空');
        return;
      }
      if (this.ca_form.id) {
        this.$http.put(baseUrl, datas).then(res => {
          if (res.code === 200) {
            this.dialogFormVisible_ca = false;
            this.getCategory();
            return;
          }
          if (res.code !== 200) {
            this.$alert('修改菜单失败');
          }
          console.log(res);
        });
      } else {
        this.$http.post(baseUrl, datas).then(res => {
          if (res.code === 200) {
            this.dialogFormVisible_ca = false;
            this.getCategory();
            return;
          }
          if (res.code !== 200) {
            this.$alert('新增菜单失败');
          }
          console.log(res);
        });
      }
    },
    setStore_cas() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_dish_unit_price_platform
      } else {
        baseUrl = this.$userList.user_menu_dish_unit_price
      }

      let datas = {
        id: this.dishprice.dish.dish_unit_prices[0].id,
        dish_id: this.dishprice.dish_id,
        dish_unit_id: this.dishprice.dish.dish_unit_prices[0].dish_unit.id,
        price: +(+this.dishprice.dish.dish_unit_prices[0].price * 100).toFixed(
          0
        ),
        vip_price: +(
          +this.dishprice.dish.dish_unit_prices[0].vip_price * 100
        ).toFixed(0),
        type: this.dishprice.dish.dish_unit_prices[0].type,
        order_seq: this.dishprice.dish.dish_unit_prices[0].order_seq,
      };
      console.log(datas, this.dishprice.dish_id);
      if (!this.testData(datas)) {
        this.$alert('价格信息不能为空');
        return;
      }
      this.$http.put(baseUrl, datas).then(res => {
        if (res.code === 200) {
          this.dialogFormVisibles = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改价格失败');
        }
        console.log(res);
      });
    },
    setForm_ca() {
      this.ca_form = {
        name: '',
        intro: '',
        // c_type: 1,    name: this.ca_form.name,
        // intro: this.ca_form.intro,
      };
    },
    onSubmit_ca(index) {
      console.log(index);
      this.dialogFormVisible_ca = true;
      if (index.id) {
        this.ca_form = index;
        return;
      }
      this.setForm_ca();
    },
    categoryList(id) {
      this.formInline.category_ids = id;
      this.user_dish_list_id = '';
      this.getTableData();
    },

    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeData = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getCategory();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //获取菜单
    getCategory() {
      this.formInline.category_ids = '';
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_list_platform
      } else {
        baseUrl = this.$userList.user_menu_list
      }
      const url =
          baseUrl +
        '/0/998?shop_id=' +
        this.formInline.shop_id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          let list = [];
          const d = new Date();
          const dates = d.getFullYear() + '' + d.getDay() + d.getDate();
          res.data.items.map(item => {
            if (item.status == 2) {
              list.unshift(item);
            } else {
              list.push(item);
            }
          });
          this.categoryData = list;
          this.formInline.category_ids = (list.length && list[0].id) || '';
          this.tableData = [];
          this.formInline.menu_id = '';
          this.handleClick();
          this.formInline.category_ids && this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    // 获取列表
    getTableData() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_dish_list_platform
      } else {
        baseUrl = this.$userList.user_menu_dish_list
      }
      this.tableData = [];
      const data = {
        page: 1,
        size: 100,
        list_params: {
          menu_id: this.formInline.category_ids,
          // category_ids: [133510774358272],
        },
      };
      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.tableData =
            (res.data.items &&
              res.data.items.map(items => {
                items.created_at = fecha.format(
                  new Date(items.created_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.updated_at = fecha.format(
                  new Date(items.updated_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.dish.dish_unit_prices = items.dish.dish_unit_prices.map(
                  item => {
                    item.price = item.price / 100;
                    item.vip_price = item.vip_price / 100;
                    return item;
                  }
                );
                return items;
              })) ||
            [];
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    //详细信息
    getEdit(row) {
      this.user_dish_list_id = row.id;
    },
    getEdits(row) {
      this.dialogFormVisibles = true;

      this.dishprice = row;
      console.log(row);
    },
    //激活 h
    activeMenu(row) {
      this.$confirm('此操将会把选中菜单设为当日菜单, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_menu_active_platform
        } else {
          baseUrl = this.$userList.user_menu_active
        }
        this.$http.post(baseUrl, { id: row.id , shop_id: this.formInline.shop_id}).then(res => {
          if (res.code === 200) {
            this.getCategory();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除菜单失败');
          }
        });
      });
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将删除菜单, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_menu_platform
        } else {
          baseUrl = this.$userList.user_menu
        }
        const url = baseUrl + '/' + row.id;

        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.getCategory();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除菜单失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible = false;
      this.dialogFormVisible_ca = false;
    },
    onSubmit() {
      this.formInline = {
        // 门店
        shop_id: this.formInline.shop_id,
        category_ids: this.formInline.category_ids,
        dish_id: '',
        menu_id: '',
        dish_unit_id: '',
        vip_price: '',
        price: '',
      };
      this.dialogFormVisible = true;
      this.activeList = [];
      this.activeNames = '请选择基础菜品';
    },
    setStore() {
      if (!this.formInline.menu_id) {
        this.$alert('请选择菜单');
        return;
      }
      if (!this.activeList.length) {
        this.$alert('请选择菜品');
        return;
      }
      const dish_unit_prices = [];
      const menu_dishes = [];
      this.activeList.map(item => {
        item.dish_unit_prices.map(items => {
          dish_unit_prices.push({
            dish_id: items.dish_id,
            dish_unit_id: items.dish_unit.id,
            price: items.price,
            vip_price: items.vip_price,
            type: items.type,
            order_seq: items.order_seq,
          });
          menu_dishes.push({
            menu_id: this.formInline.menu_id,
            dish_id: items.dish_id,
          });
        });
      });

      let data = {
        menu_dishes,
        dish_unit_prices,
      };
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_dish_platform
      } else {
        baseUrl = this.$userList.user_menu_dish
      }
      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增菜品失败');
        }
      });
    },
  },
  created() {
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform
    this.$root.setheadName();
    this.getType();
  },
};
</script>

<style >
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.right_is {
  display: flex;
  overflow: hidden;
  flex: 1;
}
.right_i {
  flex: 1;
  box-sizing: border-box;
  padding-left: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
input:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
.webLists {
  width: 400px;
  max-height: 700px;
  height: 700px;
  display: flex;
  border: solid 1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}
.webList_1_a {
  flex: 1;
  height: auto;
  background: #fff;
  overflow-x: auto;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_1_a_name {
  height: 50px;
  line-height: 50px;
  color: #fff;
  background: #131522;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-around;
}
.webList_1_a_names {
  height: 50px;
  line-height: 50px;
  color: #31a6ba;
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-around;
}
.name_color {
  background: #31a6ba;
  color: #fff;
}
.webList_2ss {
  flex: 2;
  background: #17181f;
  height: 100%;
  overflow-x: auto;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_icon {
  width: 30px;
  height: 30px;
  background: #fff;
  margin: 0 10px;
}
.webList_2_list {
  width: 100%;
  height: auto;
  color: #fff;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
}
.webList_2_img {
  background: #fff;
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.webList_2_name {
  font-size: 25px;
  font-weight: 900;
}
.webList_2_value {
  border-top: solid 1px rgba(197, 197, 197, 0.5);
  padding-top: 4px;
}
.webListValues {
  width: 500px;
  height: 700px;
  background: url('../../assets/background.jpg') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  margin-left: 20px;
  overflow-x: auto;
}
.value_name {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 900;
  margin-top: 40px;
  margin-bottom: 10px;
}
.value_namex {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 20px;
}
.value_names {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin: 10px 0;
}
.value_price {
  color: #ff7207;
  font-size: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.value_price_s {
  /* font-size: 35px;
  font-weight: 900;
  line-height: 35px; */
  margin-right: 10px;
}
.value_attr {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 20px;
}
.value_attr_s {
  overflow-y: auto;
  display: flex;
}
.value_progress {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}
.value_progress_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.bottom_centers_y {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
}
.vubuttons {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #1789fb;
  box-sizing: border-box;
  margin: 0 20px;
  border-radius: 10px;
}
.dishAttrValue {
  display: flex;
  box-sizing: border-box;
  padding-left: 130px;
  flex-wrap: wrap;
}
.tabs_list {
  display: flex;
  justify-content: space-between;
}
.tabs_lista {
  display: flex;
}
.tabs_lista_s {
  margin: 0 10px;
  color: #1890ff;
}
.colorTabs {
  color: #1890ff;
}
.tabs_listb {
  flex: 3;
}
</style>
